module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch05"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch_05"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("JANUARY 17")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("Flocks of ibis on old tractors in cleared fields sliding to sawgrass,")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("cartloads of corn, or mangoes, or clean fill dirt,")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("orchards of citrus and avocado, shade houses of the enigmatic orchid growers,")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("dusty horses in a crude corral fashioned from cypress limbs where the canal is edged with sugarcane and banana trees by the freight tracks")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse"
  }, [_vm._v("hard against the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Casa de Jesus")]), _vm._v(",")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("convicts collecting trash along the roadside in their "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("FLA CRIMINAL JUSTICE")]), _vm._v(" jumpsuits with the "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("SHERRIF’S DEPT")]), _vm._v(" school bus on the shoulder, joyless troopers overseeing what appears to be a collection of high school kids caught with bags of pot in the glove compartments of their Trans Ams,")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("security towers around the Krome Immigration Detention Center, razor-wire reefs on which the rough boats of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("loas")]), _vm._v(" bound for Lavilokan have run aground,")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page27"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("gravel quarry gouging the template, coral rock pits and barrows,")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("panel truck offering shrimp and stone crab claws from the Keys,")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("pickups selling roasted corn or watermelons, pickups heading into the fields loaded with campesinos,")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("faces of the Maya picking pole beans in the Florida sunshine,")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("Krome Avenue: the Third World starts here.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("Midwinter, and we have come to pick strawberries and tomatoes, flowers and herbs, our annual nod to hunting and gathering, a voyage into the remnants of agricultural South Florida, vanishing order endangered as the legendary panther. Sure enough, Rainbow Farms has been swallowed by exurbia, and we must head farther south in search of a passable field, crossing the canals where anhinga hitch their wings to hang like swaths of drying fabric beside the dye vats on the rooftops of Marrakech, tree farms and nurseries on all sides, freeholds of the Old "), _c('a', {
    attrs: {
      "id": "page28"
    }
  }), _vm._v("Floridians or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ranchitos")]), _vm._v(" run by cronies of long-deposed caudillos, ranks of potted hibiscus and parti-colored bougainvillea, bromeliads, queen palms, Hawaiian dwarf ixora. When we finally find a strawberry field it’s late afternoon and many have given up, but there are still a few families in the rows, hunched "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("abuelas")]), _vm._v(" with five-gallon buckets they will never fill today, and I wander out among them and lose myself altogether.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("The strawberries are not fully ripe—it is the cusp of the season—yet the field has been picked over;")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("we have come too early, and too late.")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("Lush, parsley-green, the plants spread their low stalks to flower like primitive daisies and I seek the telltale flash of red as I bend to part the dust-inoculated leaves, spooking the lazy honeybees, but mostly there is nothing, the berries are pale, fuzzed nubs. Of the rest what’s left are the morbidly overripe, fly-ridden berries melted into purple froth and those just at the bursting brink of rot—in the morning, if you bring them home,")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("these will wear a blue-green fur, becoming themselves small farms, enterprising propagators of mold.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page29"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("But here’s one perfect, heart-shaped berry, and half a row later, three more, in the shadows, overlooked. Where has my family gone? Where is everybody? I find myself abandoned in the fields, illumined by shafts of sunlight through lavender clouds, bodiless, unmoored and entirely happy.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerseIndent"
  }, [_vm._v("White eggplant and yellow peppers—")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerseIndent"
  }, [_vm._v("colored lanterns of the Emperor!")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerseIndent"
  }, [_vm._v("Lobular, chalk-red, weevil-scarred tomatoes—")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerseIndent"
  }, [_vm._v("a dozen errant moons of Neptune!")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerseIndent"
  }, [_vm._v("Vidalia onions seized by their hair and lifted")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerseIndent"
  }, [_vm._v("to free a friendly giantess from the soil!")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerseIndent"
  }, [_vm._v("Snapdragons!")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerseIndent"
  }, [_vm._v("They carry the intonation of Paris")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerseIndent"
  }, [_vm._v("on a rainy day in May, granitic odor of pears,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerseIndent"
  }, [_vm._v("consensus of slate and watered silk.")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerseIndent"
  }, [_vm._v("Elizabeth snips a dozen stems")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerseIndent"
  }, [_vm._v("with flower shears")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page30"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "extractVerseIndent"
  }, [_vm._v("scented by stalks of sage,")]), _vm._v(" "), _c('p', {
    staticClass: "extractVerseIndent"
  }, [_vm._v("rosemary, flowering basil, mint.")])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("From here the city is everything to the east, endlessly ramified tile-roofed subdivisions of houses and garden apartments, strip malls, highway interchanges, intransigent farmers holding their patchwork dirt together with melons and leaf lettuce—the very next field has been harrowed and scoured and posted for sale—already in our years here it has come this far, a tidal wave of human habitation, a monocultural bumper crop. And to the west is the Everglades, reduced and denuded but secure, for the historical moment, buffered and cosseted, left hand protecting what the right seeks to destroy. And where they meet: this fertile border zone, contested marginland inhabited by those seeking refuge from the law or the sprawl or the iron custody of the market, those who would cross over in search of freedom, or shelter, or belief, those who would buy into this world and those who would be rid of it alike in their admiration and hope for and distrust of what they see. And what they see is this: Krome Avenue. What they see is the Historical Moment caged in formidable automobiles gorging on fast food, definitive commodities of the previous century to be supplanted by what? The next Historical "), _c('a', {
    attrs: {
      "id": "page31"
    }
  }), _vm._v("Moment, and the next, like a plague of locusts descending upon the fields, or the fields descended upon, or these fields, now, just as they are.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("This may be the end of it, I suspect, the last year we make this effort. The kids are getting older and less pliable, the alligators in the irrigation canals pushed ever farther west, carrying into the heart of the sawgrass the reflection of a world grown monstrous and profound. If so, I will miss the scratched hands and the cucumber vines, ranks of hibiscus focusing their radar on the sun, the taste of stolen strawberries eaten in the rows, chalky and unwashed, no matter their senselessness here, in fields reclaimed from subtropical swamp, these last remaining acres empty or picked over or blossoming or yet to blossom, again fruit, again spoilage, again pollen-heavy dust.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("No, the Third World does not begin at Krome Avenue, because there is only one world—.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("It’s late. Cars are pulling out, mobile homes kicking up gravel, a ringing in my ears as of caravans crossing the Sahara resolves to Elizabeth calling on the cell phone—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hey, where are you?")]), _vm._v(" I can see her by the farm stand, searching "), _c('a', {
    attrs: {
      "id": "page32"
    }
  }), _vm._v("the plots and rows, not seeing me, still drifting, afloat, not yet ready to be summoned back. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("It’s time to go—where have you been?")])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("Where have I been, can I say for certain?")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("Where have I been?")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("But I know where I am—I’m here, in the strawberry field.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("Here.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("I’m right here.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a1757e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter05.vue
// module id = 84
// module chunks = 0